'use strict';

if (navigator.userAgent.match(/Trident\/7\./)) { // if IE
    $('body').on("mousewheel", function (event) {
        event.preventDefault(); // remove default behavior

        // scroll without smoothing
        var wheelDelta = event.originalEvent.wheelDelta;
        var currentScrollPosition = window.pageYOffset;
        window.scrollTo(0, currentScrollPosition - wheelDelta);
    });
}

/* global $ */

var _initialize = {
    init: function() {
        _initialize._jsSmoothScrollInit();
        _initialize._stickyNavYears();
        _initialize._toggleTimelineContent();
    },

    _jsSmoothScrollInit: function() {
        $('a[href*="#"]:not([href="#"])').click(function(event) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && 
                location.hostname === this.hostname) {

                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {
                    event.preventDefault();
                    $('html, body').stop().animate({
                        scrollTop: target.offset().top
                    }, 500);
                }
            }
        });
    },

    _stickyNavYears: function() {
        var $hero = $('#mainhero'),
            $nav = $('.b-side-menu');

        var stickyNav = function() {
            var scrollTop = $(window).scrollTop();
            if ($hero.length && scrollTop > $hero.outerHeight()) {
                $nav.addClass('b-side-menu_sticky');
            } else {
                $nav.removeClass('b-side-menu_sticky');
            }
        };

        stickyNav();
        $(window).on('scroll', stickyNav);
    },

    _toggleTimelineContent: function() {
        var $timeLineItem = $('.b-timeline__item'),
            $timeLineContent = $('.b-timeline__content'),
            $timeLineCard = $('.b-timeline__list .inverted-sec');

        var checkVisibility = function() {
            var scrollTop = $(window).scrollTop();
            var windowHeight = $(window).height();

            $timeLineContent.each(function() {
                var $self = $(this);
                if (scrollTop > $self.offset().top - $self.prev().outerHeight() * 1.5) {
                    $self.addClass('b-timeline__content_active');
                }
            });

            $timeLineCard.each(function() {
                var $self = $(this);
                if ((scrollTop + windowHeight) > $self.offset().top) {
                    $self.addClass('active');
                }
            });

            $timeLineItem.each(function() {
                var $self = $(this);
                if ((scrollTop + windowHeight) > $self.offset().top) {
                    $self.addClass('b-timeline__item_active');
                } else {
                    $self.removeClass('b-timeline__item_active');
                }
            });
        };

        checkVisibility();
        $(window).on('scroll', checkVisibility);
    }
};

$(document).ready(_initialize.init);
